import React from "react";
import Helmet from "react-helmet";
import { Portada } from "../components/molecules/Portada";
import GeneralData from "../data/GeneralData.js";
import "../css/QuienesSomos.css";
import GalleryCarousel from "../components/molecules/GalleryCarousel/index.jsx";

export const QuienesSomos = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>¿Quiénes somos? - Supre</title>
        <meta name="description" content="¿Quiénes somos?" />
      </Helmet>

      <Portada className="c-block-3 QS" Name="¿Quiénes somos?" />

      <div className="c-block-5--v2">
        <div className="g-containerQS">
          {/* Texto principal */}
          <div className="c-card-2 c-block-5__m1">
            <picture className="c-card-2__img">
              <img
                src={GeneralData.host + "images/quienes-somos.jpg"}
                alt="Quiénes Somos - Supre"
              />
            </picture>
            <p>
              Somos una empresa dedicada al otorgamiento de créditos, hacemos
              parte de un equipo de personas que reconocemos la importancia de
              impulsar a otros a alcanzar sus sueños, por eso trabajamos día a
              día para contribuir al cumplimiento de los tuyos. Queremos
              ayudarte a adquirir todo lo que mereces, de forma ágil y sin
              complicaciones.
            </p>
            <p style={{ color: "white" }}>
              <strong>¡Crecer para ayudar a crecer!</strong>
            </p>
          </div>

          {/* Bloque galería con contexto y fondo mejorado */}
          <GalleryCarousel />
        </div>
      </div>
    </>
  );
};
